import { Deserializable } from '../../deserializable';
import { WorldpayDataDto } from '../worldpay-data-dto.model';

export class OperationDto implements Deserializable {
  public MortgageAccountNumber: string;
  public SubAccountNumber?: number;
  public PayeeName: string;
  public MortgageHolderLastName: string;
  public MortgageHolderDateOfBirth?: Date;
  public PropertyPostCode: string;
  public PaymentType: string;
  public Source: string;
  public Amount: number;
  public Date: Date;
  public PaymentOperationID: number;
  public WorldPayTransactionID?: number;
  public UserFullName: string;
  public Status: string;
  public Username: string;
  public PostCode: string;
  public OperationType: string;
  public PhoneNumber: string;
  public PaymentGuid: string;
  public RefundReason: string;
  public WorldpayDataDto: WorldpayDataDto;
  public TypeOfReduction: string;
  public SOFOtherDetails: string;
  public SOFGiftDetails: string;
  public SourcesOfFunds: Array<string>;

  deserialize(input: any): this {
    Object.assign(this, input);
    this.WorldpayDataDto = new WorldpayDataDto().deserialize(input.WorldpayDataDto);

    return this;
  }
}
